import api from '../../plugins/api';

const getDealPaymentStatuses = (params) => {
  return api.get('/api/crm/deals/getDealPaymentStatuses', params);
};

export default getDealPaymentStatuses;
